import React from "react";

import MuiChip from "@mui/material/Chip";
import styled from "@mui/material/styles/styled";

import Stack, { Row, StackProps } from "@rui/Stack";

const Chip = styled(MuiChip)(({ theme }) => ({
  borderRadius: "50px",
  borderColor: theme.palette.shades.neutral[100],

  "& .chip__label": {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.shades.neutral[600],
  },

  "&.MuiChip-outlined": {
    "&:hover": {
      backgroundColor: "transparent",
      border: `1px solid ${theme.palette.shades.primary[500]}`,
      transition: "border 0.2s ease-in-out",
    },
  },

  "&.MuiChip-filled": {
    transition: "none",
    backgroundColor: theme.palette.shades.primary[500],
    border: `1px solid ${theme.palette.shades.primary[500]}`,
    "& .chip__label": {
      color: "#FFF",
      fontWeight: 500,
    },
    "& .chip__count": {
      backgroundColor: "#FFF",
      color: theme.palette.shades.primary[500],
    },
  },
}));

const ChipNumber = styled((props: StackProps) => (
  <Stack variant="center" {...props} />
))(({ theme }) => ({
  borderRadius: "6px",
  minWidth: "16px",
  width: "fit-content",
  padding: "4px",
  height: "16px",
  color: "white",
  backgroundColor: theme.palette.shades.neutral[200],
}));

const FilterChip = ({
  isSelected = false,
  label,
  numResults,
  onClick,
}: {
  isSelected?: boolean;
  label: string;
  numResults?: number;
  onClick: () => void;
}) => (
  <Chip
    clickable
    variant={isSelected ? "filled" : "outlined"}
    label={
      <Row variant="left" spacing={1}>
        <span className="chip__label">{label}</span>
        {numResults != null && (
          <ChipNumber className="chip__count">{numResults}</ChipNumber>
        )}
      </Row>
    }
    onClick={onClick}
  />
);

export default FilterChip;
